import { createRoute } from '@tanstack/react-router';

import { dashboardPageLoadable } from 'pages/dashboard-page';

import { AuthenticatedRoute } from '../authenticated-route';

export const DashboardRoute = createRoute({
  getParentRoute: () => AuthenticatedRoute,
  path: '/installations',
  component: dashboardPageLoadable,
});

export const DashboardDetailedRoute = createRoute({
  getParentRoute: () => AuthenticatedRoute,
  path: '/installations/$orgName',
  component: dashboardPageLoadable,
});
